export function isSCSession(s) {
  const t = `${s?.title || ''} ${s?.type || ''}`.toLowerCase();
  return t.includes('strength & conditioning') || t.includes('s&c');
}
